import $x from '@/utils/$x';

/**
 * iDong AI 课单课链路 - 单课 JSON 导入与课程维度运营
 *
 * 与计划链路（services/idongPush/aiCourse.js）区别：单课不挂计划，
 * 导入即建独立课程卡，推送走课程级直推（属性取自课程级运营属性表）。
 */

// 校验单课 JSON（不落库）
export const validateCourseJson = (courseJson) => {
  return $x.post('/idong/course-import/validate', {
    requestData: { courseJson },
  });
};

// 导入单课（建课程卡 + 写课程级运营属性）
// requestId：同一份 JSON 重试请沿用同一个，服务端 24h 幂等，不会重复建卡
export const importCourse = (courseJson, requestId) => {
  return $x.post('/idong/course-import/save', {
    requestData: { courseJson, requestId },
  });
};

// 单课列表（复制计划产出 + 单课导入产出，含未推送）
export const listSingleCourses = ({
  courseTitle,
  instrumentType,
  syncStatus,
  source,
  limit,
} = {}) => {
  return $x.post('/idong/course-import/list', {
    requestData: {
      courseTitle: courseTitle || undefined,
      instrumentType: instrumentType || undefined,
      syncStatus: syncStatus || undefined,
      source: source || undefined,
      limit: limit || undefined,
    },
  });
};

// 编辑课程级运营属性（器械档位/目标/难度/体验课）
export const updateCourseAttr = ({
  courseType,
  courseIdent,
  instrumentType,
  courseTarget,
  courseDifficulty,
  isTrialCourse,
}) => {
  return $x.post('/idong/course-import/attr', {
    requestData: {
      courseType,
      courseIdent,
      instrumentType,
      courseTarget,
      courseDifficulty,
      isTrialCourse,
    },
  });
};

// 导出单课 JSON（结构与导入一致）
export const exportCourseJson = ({ courseType, courseIdent }) => {
  return $x.post('/idong/course-import/export', {
    requestData: { courseType, courseIdent },
  });
};
